import { TrimbleMapsSingleSearchApi } from '@trukt/utils/TrimbleMapsSingleSearchApi';

export const trimbleMapsSingleSearchApi = new TrimbleMapsSingleSearchApi(
  process.env.TRIMBLE_MAPS_API_KEY,
);
